module.exports = __webpack_public_path__ + "static/ebook-c9c2c9c83dc116cf2acae77cbabe77b4.png";